export const SHIRTS = {
    'xs': 'Extra Small',
    's': 'Small',
    'm': 'Medium',
    'l': 'Large',
    'xl': 'Extra Large'
}

export const FileTypes = [
    'W9',
    'W4',
    'First Aid / CPR',
    'Other'
]

export const SHOE_SIZES = []
let size = 5
while( size <= 15 ){
	SHOE_SIZES.push({
		label: size%1 ? Math.floor(size)+' ½' : size,
		val: String(size)
	}); 
	size = size+0.5
}

export const BgdCheck = [
    {label: 'Yes', val: 1},
    {label: 'No/unsure, but Steens is allowed to conduct one', val: 2},
    {label: 'No, and not allowed', val: 0}
]